import { render, staticRenderFns } from "./ContestPossibleModulesCount.vue?vue&type=template&id=4434a65a&scoped=true&"
import script from "./ContestPossibleModulesCount.vue?vue&type=script&lang=js&"
export * from "./ContestPossibleModulesCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4434a65a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VBtn,VChip,VLayout})
